import { useState } from 'react'
import './CandidatePipeline.scss'
import { dummyCandidates, pipelineColumns } from 'Data/dummy_careers'
import { CandidateStageType, ICandidate } from 'Models'

export const CandidatePipeline = () => {
  const [candidates, setCandidates] = useState<ICandidate[]>(dummyCandidates)
  const [draggedCandidate, setDraggedCandidate] = useState<number | null>(null)

  const handleDragStart = (candidateId: number) => {
    setDraggedCandidate(candidateId)
  }

  const handleDragEnd = () => {
    setDraggedCandidate(null)
  }

  const handleDrop = (stage: CandidateStageType) => {
    if (draggedCandidate === null) return

    setCandidates((currentCandidates) =>
      currentCandidates.map((candidate) =>
        candidate.id === draggedCandidate
          ? {
              ...candidate,
              stage,
            }
          : candidate,
      ),
    )
    setDraggedCandidate(null)
  }

  const getCandidatesByStage = (stage: CandidateStageType) => {
    return candidates.filter((candidate) => candidate.stage === stage)
  }

  return (
    <>
      <div className='pipeline-board'>
        <div className='row g-2 flex-nowrap'>
          {pipelineColumns.map((column) => {
            const columnCandidates = getCandidatesByStage(column.id)
            {
              console.log(JSON.stringify(columnCandidates))
            }

            return (
              <div
                className='col-auto pipeline-column-wrapper border'
                key={column.id}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => handleDrop(column.id)}
              >
                <div className='pipeline-column'>
                  <div className='pipeline-column-header'>
                    <span className='pipeline-column-title'>{column.title}</span>
                    <span className='pipeline-count'>{columnCandidates.length}</span>
                  </div>
                  <div className='pipeline-column-body'>
                    {columnCandidates.map((candidate) => (
                      <div
                        className={`candidate-card ${
                          draggedCandidate === candidate.id ? 'is-dragging' : ''
                        }`}
                        key={candidate.id}
                        draggable
                        onDragStart={() => handleDragStart(candidate.id)}
                        onDragEnd={handleDragEnd}
                      >
                        <div className='candidate-name'>{candidate.name}</div>
                        <div className='candidate-position'>{candidate.position}</div>

                        <div className='candidate-meta'>
                          <span>{candidate.appliedDate}</span>
                          <span>Femi</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
